import { render, staticRenderFns } from "./TelephoneNotice.vue?vue&type=template&id=95f3cea6&scoped=true&"
import script from "./TelephoneNotice.vue?vue&type=script&lang=js&"
export * from "./TelephoneNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f3cea6",
  null
  
)

export default component.exports